export default "__VITE_ASSET__CPajuDjv__"